import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

// this simple api will only return a number to represent the number of rewards that have been granted for the given experience/promotion
const fetchEntitlements = (experienceId, promotionId) => {
  return ajaxService.helios
    .get('entitlement/granted', {
      campaignObjectId: experienceId,
      promotionId,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .catch(error => error);
};

export default {
  fetchEntitlements,
};
